<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="p01">
<h1 class="chapter"><a id="page1"></a>P<span class="small">ART</span> 1<br/>G<span class="small">HOSTS OF</span> S<span class="small">PRING</span></h1>
<p class="center"><img alt="" src="OEBPS/images/1-1.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813173894_epub_p01_r1.vue?55c64a3d